import React, { useState } from "react";
import Checkbox from "../common/Checkbox";
import instance from "../../axios";
import { logInUserInfo } from "../../Actions/Users";
import { updateLayer } from "../../Actions/Maps";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import { Box, Paper } from "@mui/material";
import Button from "../common/Button";
import { checkPrivileges, errorHandler } from "../../Helpers";

export function formSubmit(userId, payload, dispatch) {
    return instance({
        url: `api/users/${userId}`,
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data: payload,
    })
        .then((user) => {
            dispatch(logInUserInfo(user));
            dispatch(updateLayer({ id: user.map }));
            dispatch(notifySuccess("servicePerferenceInfoIsUpdated"));
            return user;
        })
        .catch((error) => {
            errorHandler(error, dispatch);
            throw error;
        });
}

const EmailServiceEstimate = (props) => {
    const originalEstimate =
        props.logInUser?.sendNotification?.estimate || false;

    const originalOutstanding =
        props.logInUser?.sendNotification?.outstanding || false;

    const originalAipms =
        props.logInUser?.sendNotification?.aipms || false;

    const [isCheckedEstimate, setIsCheckedEstimate] =
        useState(originalEstimate);

    const [isCheckedOutstanding, setIsCheckedOutstanding] =
        useState(originalOutstanding);

    const [isCheckedAipms, setIsCheckedAipms] =
        useState(originalAipms);

    const isChanged =
        isCheckedEstimate !== originalEstimate || isCheckedOutstanding !== originalOutstanding ||isCheckedAipms!==originalAipms

    const handleChangeEstimate = (event) => {
        setIsCheckedEstimate(event.target.checked);
    };

    const handleChangeOutstanding = (event) => {
        setIsCheckedOutstanding(event.target.checked);
    };

    const handleChangeAipms = (event) => {
        setIsCheckedAipms(event.target.checked);
    };

    const handleSubmitFormEstimate = async () => {
        try {
            const userPayload = {
                ...props.logInUser,
                sendNotification: {
                    ...props.logInUser.sendNotification,
                    estimate: isCheckedEstimate,
                    outstanding: isCheckedOutstanding,
                    aipms:isCheckedAipms
                },
            };

            await formSubmit(props.logInUser.id, userPayload, props.dispatch);

        } catch (error) {
            console.error("Submit error:", error);
            props.dispatch(
                notifyError("Failed to update service preferences. Try again.")
            );
        }
    };


    return (
        <Paper
            elevation={2}
            sx={{
                p: 2.5,
                borderRadius: 2,
                background: "#fff",
                width: "100%",
                maxWidth: 620,
            }}
        >
            <Box display={"flex"} alignItems={"center"} gap={2}>
                <Checkbox
                    checked={isCheckedEstimate}
                    onChange={handleChangeEstimate}
                    label={props.translate("serviceEstimateEmail")}
                />

                <Checkbox
                    checked={isCheckedOutstanding}
                    onChange={handleChangeOutstanding}
                    label={props.translate("outstandingBalanceEmail")}
                />
                <Checkbox
                    checked={isCheckedAipms}
                    onChange={handleChangeAipms}
                    label={props.translate("aipmsEmail")}
                />
            </Box>

            {checkPrivileges("userUpdate") && (
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!isChanged}
                        onClick={handleSubmitFormEstimate}
                    >
                        {props.translate("Save")}
                    </Button>
                </Box>
            )}
        </Paper>
    );
};

export default EmailServiceEstimate;
